export enum FETCH_ALL_DATASETS {
    REQUEST = 'FETCH_ALL_DATASETS_REQUEST',
    SUCCESS = 'FETCH_ALL_DATASETS_SUCCESS',
    FAILURE = 'FETCH_ALL_DATASETS_FAILURE'
}
export enum CREATE_DATASET {
    REQUEST = 'CREATE_DATASET_REQUEST',
    SUCCESS = 'CREATE_DATASET_SUCCESS',
    FAILURE = 'CREATE_DATASET_FAILURE'
}
export enum COPY_DATASET {
    REQUEST = 'COPY_DATASET_REQUEST',
    SUCCESS = 'COPY_DATASET_SUCCESS',
    FAILURE = 'COPY_DATASET_FAILURE'
}
export enum ADD_TO_DATASET {
    REQUEST = 'ADD_TO_DATASET_REQUEST',
    SUCCESS = 'ADD_TO_DATASET_SUCCESS',
    FAILURE = 'ADD_TO_DATASET_FAILURE'
}
export enum EDIT_DATASET {
    REQUEST = 'EDIT_DATASET_REQUEST',
    SUCCESS = 'EDIT_DATASET_SUCCESS',
    FAILURE = 'EDIT_DATASET_FAILURE'
}
export enum DELETE_DATASET {
    REQUEST = 'DELETE_DATASET_REQUEST',
    SUCCESS = 'DELETE_DATASET_SUCCESS',
    FAILURE = 'DELETE_DATASET_FAILURE'
}


export enum FETCH_ALL_RELATIONS {
    REQUEST = 'FETCH_ALL_RELATIONS_REQUEST',
    SUCCESS = 'FETCH_ALL_RELATIONS_SUCCESS',
    FAILURE = 'FETCH_ALL_RELATIONS_FAILURE'
}
export enum CREATE_RELATION {
    REQUEST = 'CREATE_RELATION_REQUEST',
    SUCCESS = 'CREATE_RELATION_SUCCESS',
    FAILURE = 'CREATE_RELATION_FAILURE'
}
export enum SAVE_RELATION {
    REQUEST = 'SAVE_RELATION_REQUEST',
    SUCCESS = 'SAVE_RELATION_SUCCESS',
    FAILURE = 'SAVE_RELATION_FAILURE'
}




export enum CREATE_FIELD {
    REQUEST = 'CREATE_FIELD_REQUEST',
    SUCCESS = 'CREATE_FIELD_SUCCESS',
    FAILURE = 'CREATE_FIELD_FAILURE'
}
export enum FETCH_ALL_FIELDS {
    REQUEST = 'FETCH_ALL_FIELDS_REQUEST',
    SUCCESS = 'FETCH_ALL_FIELDS_SUCCESS',
    FAILURE = 'FETCH_ALL_FIELDS_FAILURE'
}
export enum DELETE_FIELD {
    REQUEST = 'DELETE_FIELD_REQUEST',
    SUCCESS = 'DELETE_FIELD_SUCCESS',
    FAILURE = 'DELETE_FIELD_FAILURE'
}
export enum RESTORE_FIELD {
    REQUEST = 'RESTORE_FIELD_REQUEST',
    SUCCESS = 'RESTORE_FIELD_SUCCESS',
    FAILURE = 'RESTORE_FIELD_FAILURE'
}
export enum FIELD {
    EDIT_FIELD = 'EDIT_FIELD',
    ADD_FIELD = 'ADD_FIELD',
    RESET_FIELD = 'RESET_FIELD'
}
export enum SAVE_FIELDS {
    REQUEST = 'SAVE_FIELDS_REQUEST',
    SUCCESS = 'SAVE_FIELDS_SUCCESS',
    FAILURE = 'SAVE_FIELDS_FAILURE'
}



export enum CREATE_CATEGORY {
    REQUEST = 'CREATE_CATEGORY_REQUEST',
    SUCCESS = 'CREATE_CATEGORY_SUCCESS',
    FAILURE = 'CREATE_CATEGORY_FAILURE'
}
export enum FETCH_ALL_CATEGORIES {
    REQUEST = 'FETCH_ALL_CATEGORIES_REQUEST',
    SUCCESS = 'FETCH_ALL_CATEGORIES_SUCCESS',
    FAILURE = 'FETCH_ALL_CATEGORIES_FAILURE'
}
export enum CATEGORY {
    EDIT_CATEGORY = 'EDIT_CATEGORY',
    ADD_CATEGORY = 'ADD_CATEGORY',
    RESET_CATEGORY = 'RESET_CATEGORY',
    RESET_CATEGORIES = 'RESET_CATEGORIES'
}
export enum SAVE_CATEGORY {
    REQUEST = 'SAVE_CATEGORY_REQUEST',
    SUCCESS = 'SAVE_CATEGORY_SUCCESS',
    FAILURE = 'SAVE_CATEGORY_FAILURE'
}
export enum DELETE_CATEGORY {
    REQUEST = 'DELETE_CATEGORY_REQUEST',
    SUCCESS = 'DELETE_CATEGORY_SUCCESS',
    FAILURE = 'DELETE_CATEGORY_FAILURE'
}





export enum SAVE_PREDEFINED_CATEGORY {
    REQUEST = 'SAVE_PREDEFINED_CATEGORY_REQUEST',
    SUCCESS = 'SAVE_PREDEFINED_CATEGORY_SUCCESS',
    FAILURE = 'SAVE_PREDEFINED_CATEGORY_FAILURE'
}